import { useState, useEffect, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import { Toast } from "react-bootstrap";

export default function GlobalToast() {
  const [current, setCurrent] = useState(null);
  const queue = useRef([]);
  const showing = useRef(false);

  const showNext = useCallback(() => {
    if (queue.current.length === 0) {
      showing.current = false;
      return;
    }
    showing.current = true;
    const next = queue.current.shift();
    setCurrent(next);
    setTimeout(() => {
      setCurrent(null);
      setTimeout(showNext, 150);
    }, 2000);
  }, []);

  const handleApiError = useCallback((e) => {
    if (showing.current) return;
    const message = e.detail?.message || "Naməlum xəta baş verdi";
    queue.current.push({ id: Date.now() + Math.random(), message, type: "error" });
    showNext();
  }, [showNext]);

  const handleApiSuccess = useCallback((e) => {
    if (showing.current) return;
    const message = e.detail?.message || "Əməliyyat uğurla tamamlandı";
    queue.current.push({ id: Date.now() + Math.random(), message, type: "success" });
    showNext();
  }, [showNext]);

  useEffect(() => {
    window.addEventListener("api-error", handleApiError);
    window.addEventListener("api-success", handleApiSuccess);
    return () => {
      window.removeEventListener("api-error", handleApiError);
      window.removeEventListener("api-success", handleApiSuccess);
    };
  }, [handleApiError, handleApiSuccess]);

  return ReactDOM.createPortal(
    <div style={{ position: "fixed", bottom: 16, right: 16, zIndex: 200000 }}>
      {current && (
        <Toast key={current.id} show autohide delay={2000} bg={current.type === "success" ? "success" : "danger"}>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">{current.type === "success" ? "Uğurlu" : "Xəta"}</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{current.message}</Toast.Body>
        </Toast>
      )}
    </div>,
    document.body
  );
}
